import React from "react";
import {DriverDeliveryInfoPage} from "./DriverDeliveryInfoPage";

export const DriverDeliveryInfoPageWrapper = ({history, match}) => {
    return <DriverDeliveryInfoPage history={history} match={match} />;
};
